export default {
  title: {
    id: 'product_page_attractive_returns_accordion_title',
    defaultMessage: 'Get 30 days to change your mind',
  },
  freeReturns: {
    id: 'product_page__attractive_returns_free_30_day_returns',
    defaultMessage: 'Free 30-day returns',
  },
  setupReturn: {
    id: 'product_page__attractive_returns_setup_return',
    defaultMessage:
      'Set up the return in just a few clicks in your Back Market account.',
  },
  shipDevice: {
    id: 'product_page__attractive_returns_ship_device',
    defaultMessage:
      'Ship the device back for free within 30 days of receiving it.',
  },
  cashBack: {
    id: 'product_page__attractive_returns_cash_back',
    defaultMessage:
      'Get your cash back within 3 business days of the seller receiving the device.',
  },
}
